import { createSlice } from '@reduxjs/toolkit';

import { reportReviewById } from './actions';

export type ReportReviewState = {
  isReporting: boolean;
  error: string | null;
  successMessage: string | null;
};

const initialState: ReportReviewState = {
  isReporting: false,
  error: null,
  successMessage: null,
};

const reportReviewSlice = createSlice({
  name: 'reportReview',
  initialState,
  reducers: {
    resetReportState: (state) => {
      state.isReporting = false;
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reportReviewById.pending, (state) => {
        state.isReporting = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(reportReviewById.fulfilled, (state, action) => {
        state.isReporting = false;
        state.successMessage = action.payload;
      })
      .addCase(reportReviewById.rejected, (state, action) => {
        state.isReporting = false;
        state.error = (action.payload as any)?.message || 'Report failed';
      });
  },
});

export const { resetReportState } = reportReviewSlice.actions;

export const reportReviewReducer = reportReviewSlice.reducer;
